import Service from "../services/service"
import serverAction from '~/serverAction'
import {IServerData, ISubmissionCommentResponse} from '~/interfaces/serverInterfaces'
import {HTTPMethod} from '~/providers/new/httpMethod'
import {ISubmissionComment} from "~/interfaces/submissionCommentInterfaces"
import {Hash} from "~/interfaces/hashInterfaces"

export default class SubmissionCommentProvider extends Service {
  add(json: Hash & { submission_comment: Partial<ISubmissionComment> }) {
    return this.persist({ json: json, method: HTTPMethod.POST })
  }

  update(submissionCommentId: string, json: Hash & { submission_comment: Partial<ISubmissionComment> }) {
    return this.persist({ endpoint: submissionCommentId, json: json, method: HTTPMethod.PUT })
  }

  destroy(submissionCommentId: string) {
    return this.persist({ endpoint: submissionCommentId, method: HTTPMethod.DELETE })
  }

  persist({ endpoint = '', json = {}, method = 'put', query = {} }): Promise<IServerData<ISubmissionCommentResponse>> {
    return serverAction<ISubmissionCommentResponse>({
      endpoint: `/submission_comments/${endpoint}`,
      method,
      json,
    })
  }
}
